import { initJSentinel } from "./jsentinel";

if (typeof window !== "undefined" && typeof document !== "undefined") {
  void initJSentinel();
}
export {};
